export const OrderStatus = {
  CREATED: 1,
  COMPLETED: 2,
  DECLINED: 3,
  FAILED: 4,
};
